var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagentaHeart = function SvgMagentaHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB008C",
    d: "M1.042 7.5c0-3.295 2.813-5.624 5.625-5.624 1.146 0 2.383.33 3.332 1.299.941-.971 2.166-1.316 3.343-1.3 2.796.041 5.616 2.323 5.616 5.625 0 5.016-4.808 8.624-8.958 10.699C5.85 16.124 1.042 12.516 1.042 7.5"
  })));
};
export default SvgMagentaHeart;